import React, { MouseEvent } from 'react';


interface Props {
  className?: string;
  onClick?: (event: MouseEvent<Element>) => void;
  testId?: string;
}

const CloseIconExpForm = ({ className, onClick, testId }: Props) => {
  return (
    <svg width="48" height="48" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} onClick={onClick} data-testid={testId}>
      <g clipPath="url(#clip0_9895_7944)">
        <path d="M22.1673 7.47898L20.5223 5.83398L14.0007 12.3557L7.47898 5.83398L5.83398 7.47898L12.3557 14.0007L5.83398 20.5223L7.47898 22.1673L14.0007 15.6457L20.5223 22.1673L22.1673 20.5223L15.6457 14.0007L22.1673 7.47898Z" fill="#0C0F24" />
      </g>
    </svg>
  );
};

export default CloseIconExpForm;
